import { z } from 'zod';
import { fileSchema } from '../files/list';

export const clientAttachmentSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  fileId: z.string(),
  file: fileSchema,
  order: z.number(),
  externalId: z.string().nullable(),
  externalData: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ClientAttachmentSchema = z.infer<typeof clientAttachmentSchema>;
